/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_Not_SupposedInputs */



/**
* | output |
* | --- |
* | "Well, that wasn't supposed to happen" |
*
* @param {Error_Heading_Not_SupposedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_not_supposed = /** @type {((inputs?: Error_Heading_Not_SupposedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_Not_SupposedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tja, das hätte nicht passieren sollen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bon, ça n'aurait pas dû arriver")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("嗯，这本来不该发生")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("嗯，這本來不該發生的")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이런 일은 일어나면 안 되는데요")
	return /** @type {LocalizedString} */ ("Well, that wasn't supposed to happen")
});